import { useState, useEffect } from 'react'
import s from './CompanyLogo.scss'
import { Container, Col, Button, Row } from 'reactstrap'
import { FaRegImage } from 'react-icons/fa'
import { ProfilePhoto, PhotoCropper, ColorPicker } from 'components/ideal-core-ui'
import { makeGetRequest, makePutRequest } from 'utils/api'
import { getTenant } from 'utils/authService'
import { toLogoFormData, toBackgroundColorFormData } from './serializers'
import { useDispatch } from 'react-redux'

const CompanyLogo = () => {
  const [fileLogo, setFileLogo] = useState(null)
  const [cropLogo, setCropLogo] = useState(null)
  const [isUpdateProfile, setIsUpdateProfile] = useState(false)
  const [logo, setLogo] = useState('')
  const [backgroundColor, setBackgroundColor] = useState('#51525e')
  const [newBackgroundColor, setNewBackgroundColor] = useState('')
  const dispatch = useDispatch()

  useEffect(() => {
    ;(async () => {
      const { logo, backgroundColor } = await makeGetRequest('/v1/organization/get-logo', {
        headers: {
          'x-tenant-schema': getTenant()
        }
      })
      setLogo(logo)
      setBackgroundColor(backgroundColor)
    })()
  }, [])

  useEffect(() => {
    if (newBackgroundColor) {
      setBackgroundColor(newBackgroundColor)
      setNewBackgroundColor('')
      updateBackgroundColor(newBackgroundColor)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [newBackgroundColor])

  const updateLogo = async () => {
    const { logo } = await makePutRequest(
      '/v1/organization/logo',
      toLogoFormData(fileLogo, cropLogo, backgroundColor)
    )
    setIsUpdateProfile(false)
    setLogo(logo)
    dispatch({
      type: 'GET_LOGO_FETCH_SUCCESS',
      payload: {
        logo,
        backgroundColor
      }
    })
  }

  const updateBackgroundColor = async color => {
    await makePutRequest('/v1/organization/logo', toBackgroundColorFormData(color))
    dispatch({
      type: 'GET_LOGO_FETCH_SUCCESS',
      payload: {
        logo,
        backgroundColor: color
      }
    })
  }

  return (
    <Container>
      <Row>
        <Col xl="6">
          <div className={s.pictureContainer}>
            <div className={s.title}>
              <FaRegImage className={s.faIcon} />
              Company Logo
            </div>
            <div className={s.container}>
              <span>
                Your logo will be shown on the top navigation instead of the iDeal CRM logo
              </span>
              {!logo && (
                <div className={s.photoCrop}>
                  <PhotoCropper
                    onFileChange={value => setFileLogo(value)}
                    onCropComplete={value => setCropLogo(value)}
                    photo={false}
                    noPreview
                    aspect={2 / 1}
                  />
                  <Button onClick={updateLogo} disabled={!cropLogo} className={s.uploadUserImage}>
                    Upload
                  </Button>
                </div>
              )}
              {logo && !isUpdateProfile && (
                <>
                  <ProfilePhoto className={s.userImageContainer} src={logo} />
                  <Button onClick={() => setIsUpdateProfile(true)} className={s.uploadUserImage}>
                    Change Profile Image
                  </Button>
                </>
              )}
              {logo && isUpdateProfile && (
                <div className={s.photoCrop}>
                  <PhotoCropper
                    onFileChange={value => setFileLogo(value)}
                    onCropComplete={value => setCropLogo(value)}
                    photo={false}
                    noPreview
                    aspect={2 / 1}
                  />
                  <Button onClick={updateLogo} disabled={!cropLogo} className={s.uploadUserImage}>
                    Upload
                  </Button>
                  <Button
                    onClick={() => setIsUpdateProfile(false)}
                    className={s.cancelButton}
                    color="secondary"
                  >
                    Cancel
                  </Button>
                </div>
              )}
            </div>
          </div>
        </Col>
        <Col xl="6">
          <div className={s.pictureContainer}>
            <div className={s.title}>
              <FaRegImage className={s.faIcon} />
              Logo Background Color
            </div>
            <div className={s.container}>
              <span style={{ marginBottom: 10, display: 'inline-block' }}>
                This color shows behind the logo
              </span>
              <ColorPicker
                onChange={color => {
                  setNewBackgroundColor(color)
                }}
                color={backgroundColor}
                style={{ width: 100, height: 50 }}
              />
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  )
}

export default CompanyLogo
